@import (reference) '../../../../../constants/spacing.module.less';

.rma-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.divider {
  width: 100%;
  border-bottom: solid 1px var(--default--border-color--12);
}

.label-options {
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  gap: @space-8;
}

.label-option {
  padding: @space-0;
  font-size: 14px;
  line-height: 24px;
}

.configure-return-shipment-section-body {
  display: flex;
  flex-flow: column nowrap;
  gap: @space-16;
}

.label-options-container {
  display: flex;
  flex-flow: column nowrap;
  gap: @space-8;
}

.footer {
  .configure-return-shipment-section-body();
  padding: @space-0 @space-16 @space-24;
}
